import "./legal.css";
import { Document, Page } from 'react-pdf';
import TermsOfServiceContent from "../../term_of_service_content";
import PrivacyPolicyContent from "../../privacy_policy_page_content";
import { useState } from "react";
import { FaCheck } from "react-icons/fa";



const LegalDocuments = ({isLegalAgree, setIsLegalAgree, isViewedPrivacy, setIsViewedPrivacy, isViewedTerms, setIsViewedTerms,isErrors})=>{
    const [isPrivacy , setIsPrivacy] = useState(false);
    const [isViewedPrivacyInner, setIsViewPrivacyInner] = useState(isViewedPrivacy?true:false);
    const [isTermsOfService, setIsTermsOfService] = useState(isViewedTerms?true:false);
    const [isSubmit, setIsSubmit] = useState(isLegalAgree?true:false);

    const changeLegalButton = (value)=>{

        if(value == false){
            setIsTermsOfService(true);
            setIsViewedTerms(true);
        }else{
            setIsViewPrivacyInner(true);
            setIsViewedPrivacy(true);
        }

        setIsPrivacy(value);
    }

    const changeLegalSubmitButton = () =>{
        setIsSubmit(!isSubmit);
        setIsLegalAgree(!isLegalAgree);
    }



    return(
        <>
            <div className="">
                <div className="legal_button_container">
                        <button onClick={()=> changeLegalButton(false)} className="legal_button button_submit">Terms Of Service {isTermsOfService&&<FaCheck />}</button>
                        <button onClick={()=> changeLegalButton(true)} className="legal_button button_submit">Privacy {isViewedPrivacy&&<FaCheck />}</button>
                </div>
                <div className="legal_info_container">
                    {isPrivacy == false&& <TermsOfServiceContent/>}
                    {isPrivacy == true&& <PrivacyPolicyContent/>}
                </div>
                {isErrors[2]&&<div className="error-label">Error: Please Read Both the terms and Privacy.</div>}
                <button onClick={changeLegalSubmitButton} className={isSubmit?"button_submit_active":"button_submit"}>Agree</button>
            </div>
        </>
    )
}

export default LegalDocuments;